(ns minorodata.dag.api
  (:require [mold-http.core :refer [reg-event-http]]
            [minorodata.app.utils :as utils]
            [minorodata.dag.model :refer [->dag]]))


(defn format-edges [edges]
  (->> edges
       (map #(hash-map :from (first %) :to (second %)))
       vec))


(defn fetch-graph-request [_ _]
  {:http-xhrio
   {:url    "/api/dependency-graph"
    :method :post
    :params {:domain "root"}}})

(defn fetch-graph-callback [_ [error resp]]
  (if (some? error)
    {:dispatch-n [[:app.events/add-snack :error "Failed to fetch the dag"]
                  [:app.api/log :error "Failed to fetch the dag" error]]}

    (let [{:keys [nodes edges has-cycles]} resp
          new-dag       (->dag {:nodes nodes
                                :edges (format-edges edges)})]
      {:dispatch-n (utils/conj-when
                     [[:dag/update new-dag {:replace true}]]
                     has-cycles [:transformations.api/cyclic-deps-check])})))

(reg-event-http
  :dag.api/fetch-graph-legacy
  fetch-graph-request
  fetch-graph-callback)
